var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImageOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FileImageOutlined",
    clipPath: "url(#clip0_1041_4356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.31813 6.77405L6.1879 8.28379L5.59083 7.4863C5.57996 7.47175 5.56607 7.45998 5.55021 7.45189C5.53435 7.44379 5.51695 7.43959 5.49931 7.43959C5.48167 7.43959 5.46426 7.44379 5.4484 7.45189C5.43255 7.45998 5.41865 7.47175 5.40778 7.4863L3.95795 9.42218C3.94454 9.44012 3.93622 9.46166 3.93393 9.48433C3.93165 9.50699 3.93551 9.52987 3.94506 9.55035C3.9546 9.57083 3.96946 9.58809 3.98792 9.60014C4.00639 9.61219 4.02772 9.61856 4.04947 9.61851H9.3941C9.49143 9.61851 9.54518 9.50132 9.48562 9.42218L7.50263 6.77405C7.49161 6.75947 7.47759 6.7477 7.46162 6.7396C7.44564 6.73151 7.42813 6.7273 7.41038 6.7273C7.39264 6.7273 7.37512 6.73151 7.35915 6.7396C7.34317 6.7477 7.32915 6.75947 7.31813 6.77405ZM4.5129 5.75284C4.5129 5.9143 4.57412 6.06914 4.6831 6.1833C4.79207 6.29747 4.93988 6.36161 5.09399 6.36161C5.24811 6.36161 5.39591 6.29747 5.50489 6.1833C5.61386 6.06914 5.67509 5.9143 5.67509 5.75284C5.67509 5.59139 5.61386 5.43654 5.50489 5.32238C5.39591 5.20821 5.24811 5.14407 5.09399 5.14407C4.93988 5.14407 4.79207 5.20821 4.6831 5.32238C4.57412 5.43654 4.5129 5.59139 4.5129 5.75284ZM11.6981 3.41822L8.57185 0.14306C8.48468 0.0517452 8.36701 0 8.24353 0H2.0723C1.81516 0 1.60742 0.217634 1.60742 0.487013V13.1494C1.60742 13.4187 1.81516 13.6364 2.0723 13.6364H11.3698C11.627 13.6364 11.8347 13.4187 11.8347 13.1494V3.7637C11.8347 3.63433 11.7853 3.50954 11.6981 3.41822ZM10.7626 3.98742H8.02852V1.12317L10.7626 3.98742ZM10.7887 12.5406H2.65339V1.09578H7.04066V4.38312C7.04066 4.55264 7.10494 4.71523 7.21937 4.8351C7.33379 4.95498 7.48899 5.02232 7.65081 5.02232H10.7887V12.5406Z",
    fill: "#808282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1041_4356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13.6364,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImageOutlined);
export default __webpack_public_path__ + "static/media/FileImageOutlined.a4308e5d25a792d9bb2e818e59019453.svg";
export { ForwardRef as ReactComponent };